import React from 'react';
import SeaTimeline from 'components/organisms/sea-timeline/SeaTimeline';
import { Box } from '@mui/material';

function Timeline() {
  return (
    <Box sx={{mt: 5}}>
      <SeaTimeline/>
    </Box>
  );
}

export default Timeline;
